import React from 'react';
import ToggleOff from '@mui/icons-material/ToggleOffOutlined';
import ToggleOn from '@mui/icons-material/ToggleOn';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';
import Select from 'react-select';
import { normalizeThemeMode } from '../../../utils/themeColors';
import { SLIDER_NUMBER_CONTENT_ALIGNMENT_OPTIONS } from '../layout/webDashboardConstants';

const GEOMETRY_FIELDS = ['width', 'height', 'top', 'left', 'right', 'bottom'];

const WidgetBasicSettings = ({
  edit,
  setEdit,
  t,
  editFreeMovementEnabled,
  fontSizeFields,
  handleFontSizeBlur,
  handleFontSizeChange,
  showFreeGeometrySettings,
  geometryUnitLabel,
  geometryDrafts,
  setActiveGeometryField,
  handleGeometryDraftBlur,
  handleGeometryDraftChange,
  hasColorSettings,
  colorThemeMode,
}) => (
  <>
    <div className='form-item'>
      {edit.type !== 'text-title'  && (
        <>
          <label className='form-lbl' style={{ color: 'var(--header-color)' }}>{t.titleLabel}</label>
          <textarea className='add-column' rows={3} placeholder={t.titleLabel}
            style={{ padding: '8px 10px', color: 'var(--cell--color)', caretColor: 'var(--cell--color)', resize: 'vertical' }}
            value={edit.title.replace(/^\[.*?\]\s*/, '')} onChange={(e) => {
              setEdit({ ...edit, title: e.target.value });
            }} />
        </>
      )}
      <div style={{ display: 'flex', gap: '16px', marginBottom: '10px', flexWrap: 'wrap' }}>
        {edit.type !== 'background-image' && edit.type !== 'box-widget'
          && edit.type !== 'text-title'
          && edit.type !== 'camera-stream' && (
            <div className="form-item" style={{ display: 'flex', gap: '8px' }}>
              <label
                className="form-lbl"
                style={{ color: 'var(--header-color)', padding: '4px 0px' }}
              >
                {t.settingsLabels?.showTitle || 'Show Title'}
              </label>
              <input
                className="checkbox-input"
                type="checkbox"
                checked={edit.props.showTitle !== false}
                onChange={(e) => {
                  setEdit({
                    ...edit,
                    props: { ...edit.props, showTitle: e.target.checked },
                  });
                }}
              />
            </div>
          )}

        {edit.type !== 'background-image' && edit.type !== 'box-widget' &&edit.type !== 'camera-stream'&& (
          <div className="form-item" style={{ display: 'flex', gap: '8px' }}>
            <label
              className="form-lbl"
              style={{ color: 'var(--header-color)', padding: '4px 0px' }}
            >
              {t.transparentBackground}
            </label>
            <input
              className="checkbox-input"
              type="checkbox"
              checked={edit.transparentBackground ?? false}
              onChange={(e) => {
                setEdit({ ...edit, transparentBackground: e.target.checked });
              }}
            />
          </div>
        )}

        <div className="form-item">
          <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
            {t.settingsLabels?.freeMovement || 'Free Movement In Dashboard'}
          </label>
          {editFreeMovementEnabled ? (
            <ToggleOn
              style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
              onClick={() => setEdit(prev => ({
                ...prev,
                props: { ...(prev.props || {}), freeMovement: false }
              }))}
            />
          ) : (
            <ToggleOff
              style={{ color: 'var(--accent)', width: '48px', height: '40px', cursor: 'pointer' }}
              onClick={() => setEdit(prev => ({
                ...prev,
                props: { ...(prev.props || {}), freeMovement: true }
              }))}
            />
          )}
        </div>

        {edit.type === 'terminal' && (
          <div className="form-item" style={{ display: 'flex', gap: '8px' }}>
            <label
              className="form-lbl"
              style={{ color: 'var(--header-color)', padding: '4px 0px' }}
            >
              {t.addNewLine}
            </label>
            <input
              className="checkbox-input"
              type="checkbox"
              checked={edit.props.newLine ?? false}
              onChange={(e) => {
                setEdit({ ...edit, props: { ...edit.props, newLine: e.target.checked } });
              }}
            />
          </div>
        )}

        {edit.type !== 'background-image'  &&edit.type !== 'camera-stream'? fontSizeFields.map(({ key, label }) => (
          <div className="form-item" key={key} style={{ minWidth: '150px' }}>
            <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
              {label}
            </label>
            <input
              type="number"
              step="1"
              className="add-column"
              placeholder={t.settingsLabels?.auto || 'Auto'}
              value={edit.props?.[key] ?? ''}
              onBlur={() => handleFontSizeBlur(key)}
              onChange={(e) => handleFontSizeChange(key, e.target.value)}
            />
          </div>
        )) : null}

        {(edit.type === 'slider' || edit.type === 'number') ? (
          <div className="form-item" style={{ minWidth: '180px' }}>
            <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
              {t.settingsLabels?.contentAlignment || 'Content Alignment'}
            </label>
            <Select
              classNamePrefix="react-select"
              options={SLIDER_NUMBER_CONTENT_ALIGNMENT_OPTIONS}
              value={SLIDER_NUMBER_CONTENT_ALIGNMENT_OPTIONS.find(
                option => option.value === (edit.props?.contentAlignment || 'auto')
              ) || SLIDER_NUMBER_CONTENT_ALIGNMENT_OPTIONS[0]}
              onChange={selectedOption => setEdit(prev => ({
                ...prev,
                props: {
                  ...(prev.props || {}),
                  contentAlignment: selectedOption ? selectedOption.value : 'auto'
                }
              }))}
              isClearable={false}
            />
          </div>
        ) : null}
      </div>

      {showFreeGeometrySettings ? (
        <div className="form-item" style={{ marginBottom: '12px' }}>
          <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
            {t.settingsLabels?.layoutGeometry || `Layout Geometry (${geometryUnitLabel})`}
          </label>
          <div
            style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
              gap: '10px',
            }}
          >
            {GEOMETRY_FIELDS.map((field) => (
              <div className="form-item" key={field} style={{ marginBottom: 0 }}>
                <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
                  {`${t.settingsLabels?.[field] || field.charAt(0).toUpperCase() + field.slice(1)} (${geometryUnitLabel})`}
                </label>
                <input
                  className="add-column"
                  type="number"
                  step="0.01"
                  value={geometryDrafts[field]}
                  onFocus={() => setActiveGeometryField(field)}
                  onBlur={() => handleGeometryDraftBlur(field)}
                  onChange={(e) => handleGeometryDraftChange(field, e.target.value)}
                />
              </div>
            ))}
          </div>
        </div>
      ) : null}
    </div>

    {hasColorSettings ? (
      <div className="form-item">
        <label className="form-lbl" style={{ color: 'var(--header-color)' }}>
          Theme Mode
        </label>
        <div
          style={{
            width: 'min(320px, 100%)',
            display: 'flex',
            padding: 3,
            borderRadius: 9,
            background: 'rgba(19, 30, 51, 0.92)',
          }}
        >
          <div
            style={{ width: '100%', height: 38 }}
          >
            <ToggleButtonGroup
              value={colorThemeMode}
              exclusive
              onChange={(_, nextMode) => {
                if (!nextMode) return;
                setEdit((prev) => ({
                  ...prev,
                  props: {
                    ...prev.props,
                    themeMode: normalizeThemeMode(nextMode),
                  },
                }));
              }}
              style={{ width: '100%', height: '100%', gap: 0 }}
            >
              <ToggleButton
                value="dark"
                size="small"
                style={{
                  flex: 1,
                  border: 0,
                  borderRadius: 8,
                  color: colorThemeMode === 'dark' ? '#fff' : 'rgba(204, 210, 222, 0.78)',
                  background: colorThemeMode === 'dark' ? 'rgba(60, 159, 181, 0.82)' : 'transparent',
                  textTransform: 'none',
                  fontWeight: 700,
                }}
              >
                Dark
              </ToggleButton>
              <ToggleButton
                value="light"
                size="small"
                style={{
                  flex: 1,
                  border: 0,
                  borderRadius: 8,
                  color: colorThemeMode === 'light' ? '#fff' : 'rgba(204, 210, 222, 0.78)',
                  background: colorThemeMode === 'light' ? 'rgba(60, 159, 181, 0.82)' : 'transparent',
                  textTransform: 'none',
                  fontWeight: 700,
                }}
              >
                Light
              </ToggleButton>
            </ToggleButtonGroup>
          </div>
        </div>
      </div>
    ) : null}
  </>
);

export default WidgetBasicSettings;
